import FacebookIntegration from 'models/application/integration/FacebookIntegration';

export default class FacebookIntegrationService {
	toModel(integration) {
		return new FacebookIntegration(integration);
	}
}
